// extracted by mini-css-extract-plugin
export default {"ClosableModal":"ClosableModal_ClosableModal__qaxT6","MainContainer":"ClosableModal_MainContainer__slh3D","HeaderContainer":"ClosableModal_HeaderContainer__KmL0C"};